module.exports = __webpack_public_path__ + "static/media/loader_round_green_white.5d33898d.gif";